export function convertToRGB(color: string) {
    const hexColor = color.replace('#', '');
    if (hexColor.length != 6) {
        throw "Only six-digit hex colors are allowed.";
    }

    const aRgbHex: any = hexColor.match(/.{1,2}/g) || 0;
    const aRgb = [
        parseInt(aRgbHex[0], 16),
        parseInt(aRgbHex[1], 16),
        parseInt(aRgbHex[2], 16)
    ];
    return aRgb.toString();
}

export function isBrightnessColor(color: string) {
    if (!color) {
        return;
    }
    const hex = color.replace('#', '');
    const c_r = parseInt(hex.substring(0, 0 + 2), 16);
    const c_g = parseInt(hex.substring(2, 2 + 2), 16);
    const c_b = parseInt(hex.substring(4, 4 + 2), 16);
    const brightness = ((c_r * 299) + (c_g * 587) + (c_b * 114)) / 1000;
    return brightness > 155;
}